<template>
	<div class="" :class="{'pb-30': padShow }">
		<!-- 轮播图 -->
    <swipeItem :swipeList="swipeList" :height="height" :showindicators="false" bRadius="0px"></swipeItem>

		<div class="pd-16 box-s bg_f mb-5">
			<div class="flexs flex-jus mb-16">
				<div class="c6 fz-21 fw-600 l-h-21">{{data.transaction_integral}}积分</div>
				<div class="c2 fz-12">已兑{{data.transaction_number}}份</div>
			</div>

			<div class="c1 fw-500 fz-14 l-h-14 w100 text-hide">{{data.goods_introduction}}</div>
		</div>

		<div class="pd-16 box-s bg_f mb-5">
       <div class="flexs mb-10">
				 <div class="left_blue_line"></div>
				 <div class="fw-500 c1 fz-16 l-h-16 ml-8">兑换说明</div>
			 </div>

			 <div class="fz-14 c1">
				 {{data.transaction_instruction}}
			 </div>
		</div>

		<div class="ptb-16 box-s bg_f mb-5">
       <div class="flexs mb-10 plr-16 box-s">
				 <div class="left_blue_line"></div>
				 <div class="fw-500 c1 fz-16 l-h-16 ml-8">商品详情</div>
			 </div>

			 <div class="plr-16">
				 <div  v-html="data.goods_detail"></div>
			 </div>
		</div>
    
		<!-- 二维码遮罩层 -->
		<van-overlay :show="show" @click="getCancle">
			<div class=" w315 ps-50 b-radius-6 pt-55 box-s bg_shop" @click.stop>
				<img class="wh_78_80 ok_img" src="../../assets/img/icon/ok_weixin.png" alt="">
				<img class="close_icon wh_17_15" @click="getCancle" src="../../assets/img/icon/close_icon.png" alt="">
				<div class="text-center pb-21">
					<div class="fz-15 fw-500 c1">请复制兑换码添加老师微信兑换</div>
					<img class="wh_126 mr-26" :src="pupdata.TeacherQrCode" alt="">
					<div class="wh_136_40 b-radius-6 c7 bg_49 fz-13 fw-500 m0-auto">长按图片保存到本地</div>
				</div>
         
				<div class="h77 flexs pr flex-center ">
					<div class="c1 fw-500 fz-13">兑换码：</div>
					<input type="text" id="copy_text" v-model="pupdata.code" readonly class="num_dui text-center plr-8 box-s ">
					<div class="wh_65_33 text-center b-radius-6 bg_49 c7 fz-13 fw-500 l-h-33 copy_btn needsclick" ref="copy"  data-clipboard-action="copy" data-clipboard-target="#copy_text" @click="copy">复制</div>
				</div>
			</div>
		</van-overlay>
    
		<!-- 底部按钮 -->
		<div class="btn_contain">
      <div class="blue_btn" @click="getDuiHuan">
        兑换
      </div>
    </div>

		<loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>
	import loading from "@/components/loading"
  import swipeItem from '@/components/swipeItem'
	import {getShowPadding} from "@/utils/common.js";
	import { goodsDetail, goodsExchange } from "@/api/api.js";
	import Clipboard from 'clipboard';
	export default {
		components: {
      swipeItem,
			loading
		},
		data() {
			return {
				loadFlag: false,
        swipeList: [],
				padShow: false,
				show: false,
				num: '',
				data: {},
				pupdata: {},
				enterIn: false,
				duiId: '',
				copyBtn: '',
				height: ''
			};
		},
		created() {
      
			this.initData()
		},
		mounted(){
			this.height = (document.documentElement.clientWidth / 375) * 250 + 'px'
			this.copyBtn = new Clipboard(this.$refs.copy)
			this.padShow = getShowPadding()
		},
		methods: {
			async initData(){
				this.loadFlag = true
        const res = await goodsDetail({ id: this.$route.query.id })
				this.loadFlag = false
				if(res.code == 1000){
          this.data = res.data
					document.title = this.data.goods_title
					this.swipeList = [this.data.goods_picture, ...this.data.image_detail]
					console.log(this.swipeList,'this.this.swipeList')
				}else {
					 this.$toast(res.msg)
				}
			},
			// 兑换
			async getDuiHuan(){
				
				if(this.enterIn){
          return
				}
				this.enterIn = true
        const res = await goodsExchange({ id: this.$route.query.id })
				if(res.code == 1000){
					this.enterIn = false
					this.duiId = res.data.order_id
          if(res.data.good_type == 1){
						this.pupdata = res.data
            this.show = true
					} else if(res.data.good_type == 2){
						
            this.$toast.success('兑换成功');

						setTimeout(()=>{
              this.$router.replace({ path: '/exchangedetail', query:{ id: this.duiId} })
						},300)
					}
				} else {
					this.$toast(res.msg)
				}
			},
      
			// 弹框消失
			getCancle(){
        this.show = false
				this.$router.replace({ path: '/exchangedetail', query:{ id: this.duiId} })
			},
			// 复制
			copy(){
        var clipboard = new Clipboard('.copy_btn')
        clipboard.on('success', e => {
					this.$toast('复制成功')
          // 释放内存
          clipboard.destroy()
        })
        clipboard.on('error', e => {
          // 不支持复制
					this.$toast('该手机不支持自动复制')
          // 释放内存
          clipboard.destroy()
        })
			}
		}
	}
</script>
<style lang="less" scoped>
/deep/.van-overlay {
  background: rgba(0, 0, 0, 0.5);
}

.ok_img {
  position: absolute;
	top: 0;
	left: 50%;
	transform: translate(-50%, -50%);
}

.close_icon {
	position: absolute;
	top: 14px;
	right: 14px;
}

.bg_shop {
  background: url('../../assets/img/bg/jifen_bg.png') no-repeat;
  background-size: 100%;
}
</style>
